<div class="dx-fieldset" style="max-width: 600px;">

  <div class="dx-field">
    <div class="dx-field-label jobListTD">CustomerId</div>
    <div *ngIf="isManager()" class="dx-field-value">

      <dx-text-box [(value)]="model.customerId" [readOnly]="true" [showClearButton]="false"></dx-text-box>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label jobListTD">{{ 'Login' | translate }}</div>
    <div *ngIf="isManager()" class="dx-field-value">

      <dx-text-box [(value)]="model.login" [readOnly]="true" [showClearButton]="false"></dx-text-box>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label jobListTD">{{ 'Password' | translate }}</div>
    <div *ngIf="isManager()" class="dx-field-value">

      <dx-text-box [(value)]="model.password" [readOnly]="true" [showClearButton]="false"></dx-text-box>
    </div>
  </div>


  <dx-toolbar>
    <dxi-item *ngIf="isManager" location="before" widget="dxButton" [options]="{ stylingMode: 'outlined', type: 'default', text:  'Zugangsdaten erstellen' | translate , onClick: createCredentials }"></dxi-item>
  </dx-toolbar>


</div>








